<template>
<div class="comments-wrap">

<!-- <p 
class="comment-btn-mob button-text minor" 
@click="emitDisplayPostComment()">
Comment...
</p> -->

<!-- <transition name="slide-fade-y">
    <CommentPost
    class="post-comment-form"
    v-if="showPostComment"
    @emitDisplayPostComment="displayPostComment()"
    :userinfo="userinfo"
    :post="post"
    />
</transition> -->

<!-- POSTED COMMENTS -->
    <div class="comments">

        <p 
        class="comment-btn button-text" 
        @click="emitDisplayPostComment()">
        Comment...
        </p>

        <div class="comment-wrap">
            <div v-for="comment in latestComments" :key="comment.id">
                <div class="comment">



                    <p v-if="truncateComment" class="comment-text dark-grey">
                        {{ comment.comment|truncate(150) }}
                        <span v-show="comment.comment.length > 150" @click="truncateComment = false">+</span>
                    </p>
                    <p v-else class="comment-text">
                        {{ comment.comment }}
                        <span @click="truncateComment = true">x</span>
                    </p>
                    <div>
                        <small class="dark-grey" v-if="comment.fallacyMark">↳ {{comment.fallacyMark}} </small>
                        <small class="dark-grey" v-if="comment.debaterMark">→ {{comment.debaterMark}} </small>
                    </div>
                    <small class="comment-author" v-if="comment.firstname || comment.lastname">
                        <span class="dark-grey">/ </span><span class="button-text" @click="togglePopMess('Profiles coming soon')">{{comment.firstname + ' ' + comment.lastname}}</span>
                    </small>
                    <small class="comment-author" v-else><br><span>/ </span><span>Anonymous</span></small>
                    
                </div>
            </div>
        </div>
    </div>

    <div class="gradient-left"></div>
    <div class="gradient-right"></div>
    
</div>
</template>

<script>
import { db, auth, time } from '../db'
import * as firebase from 'firebase'
import IconCancel from '../assets/icons/IconCancel.vue'
import CommentPost from '../components/CommentPost.vue'

export default {
    name: 'Comments',
    props: [
        'post',
        'userinfo',
        'showPostComment'
    ],
    components: {
        IconCancel,
        CommentPost
    },
    data() {
        return {
            truncateComment: true,
            commentsData: this.post.comments,
        }
    },
    filters: {
        truncate: function(value, limit) {
        if (value.length > limit) {
            value = value.substring(0, (limit - 3)) + '...';
        }
        return value
        }
    },
    computed: {
        latestComments () {
            if (!this.commentsData) {
                return []
            } else {
                return this.commentsData.slice().reverse()
            }
        },
        
    },
    methods: {
        emitDisplayPostComment() {
            this.$emit('emitDisplayPostComment')
        },
        togglePopMess(payload) {
            this.$store.commit('togglePopMess', payload)
        },
        displayPostComment () {
            this.showPostComment = this.showPostComment != true
        },
    }
}
</script>
<style lang="scss" scoped>
// @import "../scss/_variables.scss";
.comments-wrap {
    position: relative;
    // overflow: hidden;
    .comment-btn-mob { 
        display: none;
    }

    // .post-comment-form {
    //     position: fixed;
    //     width: 100%;
    //     z-index: 20;
    //     bottom: 0;
    // }


    .comments {
        display: flex;
        width: 100%;    
        overflow: scroll;
        margin-top: $main-margin;
        padding-bottom: $main-margin;

        .comment-btn {
            padding-left: $grid-padding;
            width: $col2;
            min-width: $col2;
            margin-right: $main-margin;
            line-height: 1.2;
            border-bottom: none;
            margin-top: 0;
        }

        form {
            position: relative;
        }
        .comment-input {
            padding-left: $grid-padding;
            width: $col3;
            min-width: $col3;
            margin-right: $main-margin;
            line-height: 1.2;
            border-bottom: none;
            resize: none;
        }

        .comment-wrap {
            padding-right: $grid-padding;
            display: flex;
            .comment {
                width: $col3;
                margin-right: $main-margin;
                .comment-text {
                    margin: 0;  
                    overflow-wrap: break-word;                
                }
                .comment-author {
                    white-space: pre;
                }
            }   
        } 
    }
    .gradient-left, .gradient-right {
        width: $grid-padding;
        height: 100%;
        position: absolute;
        top: 0;
        pointer-events: none;
        opacity: .8;
    }
    .gradient-left {
        left: 0;
        background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.8) 50%, rgba(255,255,255,0) 100%);
    }
    .gradient-right {
        right: 0;
        background: linear-gradient(-90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.8) 50%, rgba(255,255,255,0) 100%);
    }
}
// MOBILE
@media #{$mobile} {    
.comments-wrap {
    .comment-btn-mob { 
        display: block;
        position: absolute;
        left: $main-margin-mobile;
        top: -56px;
    }
    .post-comment-form {
        padding-top: 20px;
        padding-bottom: 20px;
        .comment-input {
            margin: 0 $main-margin-mobile;
        }
        textarea {
            resize: none;
            font-size: $h1-mobile;
        }
        .close {
            margin-right: $main-margin-mobile;
        }
        .big-btn { 
            height: 60px;
            h1 {
                margin: 0 $main-margin-mobile;
            }
        }
    }
    .comments {
        .comment-btn { 
            display: none;
        }
        .comment-input {
            padding-left: 10px !important;
            min-width: 30vw !important;
            width: 30vw !important;
            font-size: $p2;
        }
        .button {
            margin-left: $main-margin-mobile !important;
        }
        .comment-wrap {
            margin-left: $main-margin-mobile;
            .comment {
                width: 60vw !important;
                margin-right: $main-margin-mobile;
                font-size: $p2;
                p {
                font-size: $p2;
                }
            }
        }
    }
    .gradient-left {
        display: none;
    }

    }
}

</style>
